import React, { Fragment, useState, useEffect, useContext } from "react";
import ConfirmModal from "./ConfirmModal";
import { useTranslation } from "react-i18next";
import { Alert } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faSpinner, faWarning } from "@fortawesome/free-solid-svg-icons";
import { postMethod } from "../../requests";
import { BasicContext } from "../../App";

const SignOutFromClassModal = (props) => {
    const { t } = useTranslation();
    const { onClose, onProceed, settings, c } = props;
    const { checkServerData } = useContext(BasicContext);
    const [loading, setLoading] = useState(true);
    const [showAbsenceCountAlert, setShowAbsenceCountAlert] = useState(false);

    const hoursEarlier = (date, hours) => {
        const newDate = new Date(date);
        newDate.setHours(newDate.getHours() - hours);
        return new Date(newDate);
    };

    const checkUserAbsenceCount = async () => {
        const res = await postMethod("/check-user-absence-count");
        if (checkServerData(res)) {
            setShowAbsenceCountAlert(res.data.absenceCount);
            setLoading(false);
        }
    };

    useEffect(() => {
        checkUserAbsenceCount();
        // eslint-disable-next-line
    }, []);

    return (
        <ConfirmModal
            show={true}
            cancelTxt={t("signOutFromClassModal.onCancelTxt")}
            proceedTxt={t("signOutFromClassModal.onProceedTxt")}
            onClose={onClose}
            onProceed={onProceed}
            title={t(c.statusCode === "SIGNED" ? "signOutFromClassModal.title" : "signOutFromWaitingListModal.title")}
            text={
                <>
                    {loading ? (
                        <p className="fs-5 text-center my-3">
                            {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                        </p>
                    ) : (
                        <Fragment>
                            <p>{t(c.statusCode === "SIGNED" ? "signOutFromClassModal.text" : "signOutFromWaitingListModal.text")}</p>
                            {c.statusCode === "SIGNED" && (
                                <>
                                    {c.c.early_cancel_available === "N" ? (
                                        <Alert variant="warning">
                                            <FontAwesomeIcon icon={faWarning} className="me-2" />
                                            {t(`warning.signInWillNotBeReturnedNoEarlyCancellations`)}
                                        </Alert>
                                    ) : new Date() < hoursEarlier(c.c.class_start_time, settings.filter((e) => e.setting_code === "CANCELLATION_WINDOW")[0].setting_value_int) ? (
                                        <Alert variant="info">
                                            <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
                                            {t(`info.signInWillBeReturned`)}
                                        </Alert>
                                    ) : (
                                        <Fragment>
                                            <Alert variant="warning">
                                                <FontAwesomeIcon icon={faWarning} className="me-2" />
                                                {t(`warning.signInWillNotBeReturned`)}
                                            </Alert>
                                            {showAbsenceCountAlert && (
                                                <Alert variant="warning">
                                                    <FontAwesomeIcon icon={faWarning} className="me-2" />
                                                    {t(`warning.userWillBeBlocked`)}
                                                </Alert>
                                            )}
                                        </Fragment>
                                    )}
                                </>
                            )}
                        </Fragment>
                    )}
                </>
            }
        />
    );
};

export default SignOutFromClassModal;
